// extracted by mini-css-extract-plugin
export var label = "_ip-2";
export var slideContainer = "_ip-0";
export var slider = "_ip-1";